import { Text } from '@fluentui/react-components';
import { formatAmount, formatPrice, formatUnitAmount } from '../utils/price';
import type { Price } from '../types/catering';

export type PriceTextProps = {
  price?: Price;
  amount?: number;
  currency?: string;
  size?: 'small' | 'medium' | 'large';
  weight?: 'regular' | 'semibold' | 'bold';
  includeCurrency?: boolean;
};

export function PriceText({
  price,
  amount,
  currency,
  size = 'medium',
  weight = 'regular',
  includeCurrency = true,
}: PriceTextProps) {
  const textSize = size === 'small' ? 200 : size === 'large' ? 500 : 300;
  return (
    <Text size={textSize} weight={weight}>
      {price
        ? includeCurrency
          ? formatPrice(price)
          : formatAmount(price)
        : formatUnitAmount(amount ?? 0, currency)}
    </Text>
  );
}
